export default __webpack_public_path__ + "static/collin-22638d7b5f8e30d7c92e22f4cfd2bc4e.png";